import { Box, Button, Grid2, Typography } from '@mui/material'
import { GRAY_COLORS } from 'asterX-UI'
import { UserInfo } from 'asterX-UI/DataDisplay'
import { ArrowLeftIcon } from 'asterX-UI/Icons'
import ButtonGroupsByStep from 'components/ButtonGroupsByStep/ButtonGroupsByStep'
import { CommentHistory } from 'components/CommentHistory/CommentHistory'
import { CustomTabs } from 'components/CustomTabs/CustomTabs'
import PageContainer from 'components/PageContainer/PageContainer'
import { ClientTab } from 'components/PageTabs/ClientTab'
import { CollateralTab } from 'components/PageTabs/CollateralTab'
import { ContractTab } from 'components/PageTabs/ContractTab'
import { DDSTab } from 'components/PageTabs/DDSTab'
import { DetailsTab } from 'components/PageTabs/DetailsTab'
import { FilesTab } from 'components/PageTabs/FilesTab'
import { GuaranteeTab } from 'components/PageTabs/GuaranteeTab'
import Stepper from 'components/Stepper/Stepper'
import { useAuthStore } from 'context/AuthStore'
import { useContractStore } from 'context/ContractStore'
import { MANAGER } from 'lib/constants/roles'
import { getFomattedDate, getFullName } from 'lib/utils'
import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { HOME_PATH } from 'routes/constants.routes'
import { CookieService } from '../../lib/utils/services/cookie.service'
import { CreditFlow } from '../../lib/api/services/creditFlow.service'
import QrIcon from '../../asterX-UI/Icons/QR_Icon'
import InfoModalButton from '../../components/InfoModalButton/InfoModalButton'


const getContractTabList = role => {
  const tabs = [
    {
      label: 'Контракт',
      component: ContractTab
    },
    {
      label: 'Клиент',
      component: ClientTab
    },
    {
      label: 'Обеспечение',
      component: CollateralTab
    },
    {
      label: 'Гарант',
      component: GuaranteeTab
    },
    {
      label: 'Реквизиты',
      component: DetailsTab
    },
    role === 'ACCOUNTANT' && {
      label: 'ДДС',
      component: DDSTab
    },
    {
      label: 'Файлы',
      component: FilesTab
    }
  ]

  return tabs.filter(Boolean)
}

const Contract = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { authStore } = useAuthStore()
  const {
    contractStore: { step, stepperList, loanApplicationData, managerWorking },
    contractStoreFunc: { getApplicationById, getFileCategories }
  } = useContractStore()

  const getIdFromUrl = () => {
    const urlId = location.pathname.split('/').pop()
    return !isNaN(Number(urlId)) ? urlId : null
  }

  const id = getIdFromUrl() || null
  const garantee = loanApplicationData?.collaterals?.find(collet=>collet.type==='CLIENT')?.clientGuarantee
  const client=loanApplicationData?.client

  useEffect(() => {
    if (!id || managerWorking) return
    const fetchApplication = () => getApplicationById(id)
    if (authStore.isUserRole === MANAGER) {
      const interval = setInterval(fetchApplication, 10000)
      fetchApplication()
      return () => clearInterval(interval)
    }
    fetchApplication()
  }, [id, authStore.isUserRole, managerWorking])

  useEffect(() => {
    if (['userUploadBankDocs'].includes(loanApplicationData?.status?.code)) {
      getFileCategories(loanApplicationData?.id)
    }
  }, [loanApplicationData?.status?.code])

  useEffect(() => {
    const contractId = CookieService.getCookie('redirectToCreditFlowByContract_ID');
    if (!contractId) return;


    const checkContractAndRedirect = async () => {
      try {
        const res = await CreditFlow.getContractList({ limit: 100, offset: 0 })
        const foundContract = res?.data?.list?.find(
          (item) => item?.id?.toString() === contractId?.toString()
        );
        if (foundContract) {
          CookieService.deleteCookieEverywhere('redirectToCreditFlowByContract_ID');
          navigate(`/contract/${foundContract.loanApplication.id}`);
        } else {
          console.warn('Контракт с таким ID не найден в списке');
          CookieService.deleteCookieEverywhere('redirectToCreditFlowByContract_ID');
        }
      } catch (e) {
        console.error('Ошибка при получении списка контрактов:', e);
      }
    };

    checkContractAndRedirect();
    CookieService.deleteCookieEverywhere('redirectToCreditFlowByContract_ID');
  }, []);

  useEffect(() => {
    const alreadyRedirected = CookieService.getCookie('redirectToCreditFlowByContract_ID')

    if (!alreadyRedirected && loanApplicationData?.contract?.id) {
      CookieService.setCookie(
        'redirectToContractId',
        loanApplicationData.contract.id.toString()
      )
    }
  }, [loanApplicationData?.contract?.id])

  return (
    <PageContainer>
      <Grid2 size={{ xs: 12 }}>
        <Button size="small" onClick={() => {
          navigate(HOME_PATH)
          CookieService.deleteCookieEverywhere('redirectToContractId');
          CookieService.deleteCookieEverywhere('redirectToCreditFlowByContract_ID');
        }} sx={{ display: 'flex', gap: '4px' }}>
          <ArrowLeftIcon />
          Назад
        </Button>
      </Grid2>
      <Grid2 container sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Grid2>
          <Typography sx={{ fontSize: 14, color: GRAY_COLORS[600] }}>
            {getFomattedDate(loanApplicationData.createDate)}
          </Typography>
          <Grid2 container sx={{display: 'flex', flexDirection:'row',
            alignItems: 'center',justifyContent: 'space-between', gap:'16px'}}>
          <Typography
            sx={{ fontSize: 24, fontWeight: 600, color: GRAY_COLORS[900] }}
          >{`Контракт №${loanApplicationData?.contractId || '-'}`}</Typography>
            {loanApplicationData?.isSignedOnline===true && (
              <InfoModalButton
                icon={<QrIcon/>}
                tooltip={
                  "Контракт подписан онлайн"
                }
                modalTitle={
                  "Контракт подписан онлайн"
                }
                modalText={<Box>
                  <Typography>
                    Данный контракт был подписан клиентом через систему онлайн-подписания
                    с использованием личной ЭЦП и сервиса Egov.<br/>
                    <b>Участники:</b>  Клиент: {getFullName(client?.firstName, client?.lastName,client?.patronymic)}
                    {garantee ? `,
                      Гарант: ${getFullName(garantee?.firstName,
                      garantee?.lastName,garantee?.patronymic)}` : ''}
                    <br />
                    <b>Метод:</b> вход через Egov + подтверждение ЭЦП
                    <br />
                    <b>Безопасность:</b> уникальная ссылка и OTP-подтверждение при повторном входе
                    <br />
                    <b>Даты:</b> зафиксированы момент подписи и стороны, которые подписали документ
                    <br />
                    <b>После подписания:</b> документ хранится в системе, доступен для просмотра сторонам
                    <br/>
                    <br/>
                    <Typography
                      variant="body2"
                      sx={{
                        mt: 2, fontSize: 12, color: GRAY_COLORS[600], display: 'flex', alignItems: 'center', gap: 2,
                        fontStyle: 'italic', lineHeight: 1.5
                      }}>
                      <span style={{fontSize: 16, lineHeight: 1}}>ℹ</span>
                      Онлайн-подписание позволяет исключить печать и сканирование,
                      ускоряет процесс и повышает безопасность данных.
                    </Typography>
                  </Typography>
                </Box>}
                modalVariant={"success"}
                btnSx={{
                  color: 'success.main',
                  background: 'rgba(76, 175, 80, 0.07)',
                  '&:hover': {
                    background: 'rgba(76, 175, 80, 0.17)'
                  }
                }}
              />
            )
            }
          </Grid2>
        </Grid2>
        <Grid2>
          <UserInfo
            fullName={loanApplicationData?.clientFullName}
            phone={loanApplicationData?.client?.mobilePhone1?.toString()?.toPhone()}
          />
        </Grid2>
      </Grid2>

      <Grid2 size={{ xs: 12 }}>
        <Stepper steps={stepperList} currentStep={step} />
      </Grid2>

      <ButtonGroupsByStep page={'contract'} />

      <Grid2 container sx={{ display: 'flex', flexWrap: 'nowrap', gap: '24px' }}>
        <CustomTabs getTabs={getContractTabList(authStore.isUserRole)} page={'contract'} />
        <CommentHistory />
      </Grid2>
    </PageContainer>
  )
}

export default Contract
